<template>
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6228 13.8241V5.91342C18.6228 5.20851 18.2468 4.56626 17.6359 4.22163L10.7904 0.258467C10.1795 -0.0861558 9.44327 -0.0861558 8.83235 0.258467L1.98688 4.20597C1.37595 4.56626 1 5.20851 1 5.91342V13.8241C1 14.5133 1.37595 15.1713 1.98688 15.5159L8.83235 19.479C9.44327 19.8237 10.1795 19.8237 10.7904 19.479L17.6359 15.5159C18.2468 15.1713 18.6228 14.5133 18.6228 13.8241Z"
      fill="#1A6AFF"
    />
    <path
      d="M11.7616 9.97056L6.07534 9.51629C5.90303 9.51629 5.77771 9.32831 5.77771 9.14034V6.25803C5.77771 6.05439 5.91869 5.91341 6.07534 5.92907L11.7616 6.38335C11.9339 6.38335 12.0593 6.57133 12.0593 6.7593V9.64161C12.0593 9.84525 11.9183 9.98623 11.7616 9.97056Z"
      fill="white"
    />
    <path
      d="M15.1295 12.7902L12.9052 12.6179C12.7798 12.6179 12.6859 12.4769 12.6859 12.3359V6.74365C12.6859 6.60266 12.7798 6.49301 12.9052 6.49301L15.1295 6.66532C15.2549 6.66532 15.3488 6.80631 15.3488 6.94729V12.5396C15.3488 12.6806 15.2549 12.7902 15.1295 12.7902Z"
      fill="white"
    />
    <path
      d="M11.8242 12.5552L9.42748 12.3672C9.30216 12.3672 9.1925 12.2263 9.1925 12.0696V10.7538C9.1925 10.5971 9.30216 10.4875 9.42748 10.5031L11.8242 10.6911C11.9495 10.6911 12.0591 10.8321 12.0591 10.9887V12.3046C12.0591 12.4612 11.9495 12.5709 11.8242 12.5552Z"
      fill="white"
    />
    <path
      d="M8.39363 12.2732L5.99693 12.0853C5.87162 12.0853 5.76196 11.9443 5.76196 11.7876V10.4718C5.76196 10.3151 5.87162 10.2055 5.99693 10.2212L8.39363 10.4091C8.51895 10.4091 8.6286 10.5501 8.6286 10.7068V12.0226C8.6286 12.1792 8.51895 12.2889 8.39363 12.2732Z"
      fill="white"
    />
    <path
      d="M14.0801 14.247C14.0801 14.247 14.0644 14.247 14.0487 14.247L5.13552 13.5421C4.61859 13.4951 4.2113 13.0095 4.2113 12.4456V7.32324C4.2113 7.1196 4.36795 6.96295 4.57159 6.96295C4.77523 6.96295 4.93188 7.1196 4.93188 7.32324V12.4456C4.93188 12.6492 5.0572 12.8059 5.18251 12.8215L14.0957 13.5265C14.2994 13.5421 14.456 13.7144 14.4403 13.9181C14.4403 14.1061 14.268 14.2627 14.0801 14.2627V14.247Z"
      fill="#34AFFF"
    />
  </svg>
</template>
